import { render, staticRenderFns } from "./editJobGrade.vue?vue&type=template&id=f454a528&scoped=true"
import script from "./editJobGrade.vue?vue&type=script&lang=js"
export * from "./editJobGrade.vue?vue&type=script&lang=js"
import style0 from "./editJobGrade.vue?vue&type=style&index=0&id=f454a528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f454a528",
  null
  
)

export default component.exports